module.exports = "<app-nav></app-nav>\n<div class=\"spacer\"></div>\n<router-outlet></router-outlet>\n<app-footer></app-footer>\n"